import { FC, useState } from 'react'
import { Form, Typography } from 'antd'
import { DatePicker, Modal } from '../../../../../../../ui'
import { ButtonsBlock } from '..'
import { useTranslation } from 'react-i18next'
import { MONTHS_LOWER, getZDLite, getZDFull } from '../../../../../../config'
import agent from '../../../../../../../../services/request'
import moment from 'moment/moment'

const { Title } = Typography

interface IModalZD {
    isModalVisible: boolean
    onCancel: () => void
    type: 'lite' | 'full' | null
    companyName: string
}

function parseFilename(contendDisposition: string){
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contendDisposition as string);
    if (matches != null && matches[1]) {
        return matches[1].replace(/['"]/g, '');
    }
    return null
}

const ModalZD: FC<IModalZD> = ({ isModalVisible, onCancel, type, companyName }) => {
    const { t } = useTranslation()
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [submitClicked, setSubmitClicked] = useState<boolean>(false)

    const handleSubmit = async () => {
        setSubmitClicked(true)
        const companyNameNormalized = companyName
            .trim()
            .replace(/\s+/g, ' ')
            .replace(/[\\/:*?"<>|]/g, '')
            .replace(/\s*_/g, '_')
            .replace(/_\s*/g, '_')

        setLoading(true)
        try {
            const values = await form.validateFields()
            const date = values.date.format('YYYY-MM')

            const url = type === 'lite' ? getZDLite.link : getZDFull.link
            const response = await agent.get(url, {
                params: { date },
                responseType: 'blob',
            })
            const file = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            let fullFilename = ''
            if (type === 'full') {
                const contentDisposition = response.headers['content-disposition']
                const backFilename = parseFilename(contentDisposition)
                const firstPart = backFilename?.split('__')[0]
                const secondPart = backFilename?.split('__')[1]
                fullFilename = `${firstPart}_${companyNameNormalized}_${secondPart}.xlsx`
            }

            const monthStr = date.split('-')[1]
            const month = Number(monthStr)
            const filename =
                type === 'lite'
                    ? `ЗД lite_поставка за ${MONTHS_LOWER[
                          month
                      ].toLowerCase()}_${companyNameNormalized}.xlsx`
                    : fullFilename

            const link = document.createElement('a')
            link.href = URL.createObjectURL(file)
            link.download = filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(link.href)

            onCancel()
        } catch (err: any) {
            console.log(err.text())
            form.setFields([{ name: 'date', errors: [t('greenTools.errorNoData')] }])
        } finally {
            setLoading(false)
            setSubmitClicked(false)
        }
    }

    return (
        <Modal isModalVisible={isModalVisible} onCancel={onCancel} bodyStyle={{ width: '600px' }}>
            <Form form={form} layout="vertical" onSubmitCapture={(e) => e.preventDefault()}>
                <Title level={4} style={{ marginBottom: 24 }}>
                    {t('greenTools.labelModalZD')}
                </Title>

                <Form.Item
                    label={t('greenTools.labelDateModalZD')}
                    name="date"
                    rules={[
                        {
                            required: true,
                            message: t('rules.required'),
                        },
                    ]}
                >
                    <DatePicker
                        picker="month"
                        format="MMMM, YYYY"
                        customStyle={{ width: '100%' }}
                        disabledDate={(date) =>
                            date.isAfter(moment()) || date.isBefore(moment('2024-02-01'), 'month')
                        }
                    />
                </Form.Item>

                <ButtonsBlock
                    cancelAction={onCancel}
                    confirmAction={handleSubmit}
                    confirmTitle={t('greenTools.buttonConfirm')}
                    loading={loading}
                    margin
                    confirmDisabled={submitClicked}
                />
            </Form>
        </Modal>
    )
}

export default ModalZD
